module.exports = __webpack_public_path__ + "static/merino-shoe-87c0b69a374e94b6e8bd7ba3d4261df9.png";